import { TurnState } from '@colonist/game-states';
import { GameStateEnums } from '../../../../../shared/GameEnums.ts';
import { TimeUtils } from '@colonist/utils';
import { ClientUserState } from '../../ClientUserState.ts';
export class UIGameBeginnerHintsController {
    onEvent(data, eventType) {
        switch(eventType){
            case GameStateEnums.UIGameEventEnums.GameStateUpdated:
                this.gameStateUpdated();
                break;
            default:
                break;
        }
    }
    gameStateUpdated() {
        if (!this.shouldRequestBeginnerHint()) return;
        const requestHintTime = this.uiGameManager.gameController.currentState.allocatedTime;
        const timerEndTime = Date.now() / TimeUtils.MILLISECONDS + TimeUtils.secondsLeftForCurrentState(this.uiGameManager.gameController.timeLeftInCurrentState);
        const remainingTime = Math.round(timerEndTime - Date.now() / TimeUtils.MILLISECONDS);
        if (remainingTime == requestHintTime) this.uiGameManager.socketGameSend.requestHintForBeginner(false);
    }
    shouldRequestBeginnerHint() {
        var _ClientUserState_userState;
        if (!this.uiGameManager.gameController.isMyTurn) return false;
        if (this.uiGameManager.gameController.currentState.turnState != TurnState.InitialPlacement) return true;
        if ((_ClientUserState_userState = ClientUserState.userState) === null || _ClientUserState_userState === void 0 ? void 0 : _ClientUserState_userState.hasZeroCompletedGames()) return true;
        return false;
    }
    constructor(uiGameManager){
        this.uiGameManager = uiGameManager;
        this.uiGameManager.eventController.registerUIGameMechanic(this);
    }
}
